<template>
	<v-container class="welcome-page">
		<img
			v-if="welcomeLogo"
			:src="welcomeLogo"
			alt="Clowder Icon"
			class="logo-image"
			loading="lazy"
		/>

		<v-btn
			class="login-button"
			@click="navigateToLoginPage"
		>
			{{loginButtonName}}
		</v-btn>

		<a
			v-if="isUserPreferExternalRegister"
			class="create-account-link"
			@click="navigateToRegisterPage"
		>
			{{signupButtonName}}
		</a>
	</v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import TokenService from '@/services/token.service'

export default {
	name: 'LoginPage',
	data: () => ({}),
	computed: {
		...mapGetters('settings', ['login']),

		isUserPreferExternalRegister() {
			const {
				registration_url: registrationUrl
			} = this.login || {}

			return !!registrationUrl
		},
		hostName() {
			return window.location.hostname || 'localhost';
		},
		protocol() {
			return window.location.protocol || 'http'
		},
		deviceId() {
			return TokenService.getDeviceIdFromStorage()
		},
		externalLoginUrl() {
			return `${this.protocol}//${this.hostName}/oauth?device-id=${this.deviceId}&redirect_url=${this.protocol}//${this.hostName}${process.env.VUE_APP_PUBLIC_PATH}oauth2-callback`;
		},
		welcomeLogo() {
			const {
				wp_logo_x3: wpLogoX3
			} = this.login || {}

			return wpLogoX3;
		},
		signupButtonName() {
			const {
				signup_ss_button: signUpButtonName
			} = this.login || {}

			return signUpButtonName || 'Create Account';
		},
		loginButtonName() {
			const {
				login_ss_button: logInButtonName
			} = this.login || {}

			return logInButtonName || 'Login to your Account';
		}
	},
	methods: {
		navigateToLoginPage() {
			const {
				external_login: externalLogin,
			} = this.login || {}

			const isUserPreferExternalLogin = !!externalLogin;

			if (isUserPreferExternalLogin) {
				window.location.href = this.externalLoginUrl
			} else {
				this.$router.push({ name: 'login' })
			}
		},
		isDeepLink(link = '') {
			if (!link) {
				return false;
			}

			return !link.startsWith('http');
		},
		navigateToRegisterPage() {
			const {
				registration_url: registrationUrl,
			} = this.login || {}

			if (this.isDeepLink(registrationUrl)) {
				this.$router.push({
					name: 'registration'
				})
			} else {
				window.location.href = registrationUrl
			}
		}
	},
}
</script>

<style lang="scss">
.welcome-page {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.logo-image {
	width: 40%;
}

.welcome-page .v-btn.login-button {
	background-color: var(--welcome-button-login-background) !important;
	color: var(--welcome-button-login-color) !important;
	border-radius: 8px;
	height: 50px !important;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
	max-width: 320px;
	width: 100%;
	text-transform: none;
}

.login-button span {
	font-size: 16px;
}

.create-account-link {
	font-size: 18px;
	font-family: Montserrat, sans-serif;
	font-weight: bold;
	color: var(--welcome-button-signup-color) !important;
	margin-top: 30px;
	text-decoration: underline;
	cursor: default;
}

.terms-of-use {
	a {
		color: var(--link) !important;
	}
}
</style>
